import { decryptApi } from '@/public/utils/decrypt-api'
import './style.scss'
export default {
  name: 'KyeFieldDecrypt',
  props: {
    // 用于执行判断解密相关逻辑。（data数据中必须存在以 `Mask`结尾的属性以及属性值）
    data: Object,

    // 指定需要解密的字段，同时也是组件展示的属性值
    prop: String,

    // 设置属性样式class。
    className: String,

    // 是否禁止自动解密
    unauto: Boolean,

    // 指定解密时，存储到后端的唯一值，便于后端索引查找。（默认为id）
    idKey: {
      type: String,
      default: 'id'
    },

    // 解密时，存储到后端的解密按钮中文名
    name: {
      type: String,
      default: ''
    }
  },
  data() {
    // 使用公共解密API
    this.decryptApi = decryptApi
    return {
      // 是否解密
      decrypted: false
    }
  },
  created() {
    this.watchEncryptField()
  },
  beforeDestroy() {
    // 取消监听
    this.unWatchEncryptField && this.unWatchEncryptField()
  },
  render() {
    const value = this.decryptApi.getValue(this.$props.data, this.$props.prop)
    const decryptClass = [this.decrypted ? 'kye-filed-decrypt' : 'kye-field-encrypt', this.$props.className]
    return (
      <span class={decryptClass} on-click={this.handleClick}>
        {value}
      </span>
    )
  },
  methods: {
    watchEncryptField() {
      // 处理数据层可能发生， 使用 Object.assign(data, {})方式添加不触发 data的watcher的场景
      // 建议所有开发者，在使用watch时，调整颗粒度，不要直接监听整个data或者直接deep。以免造成性能浪费
      this.unWatchEncryptField = this.$watch(
        () => this.decryptApi.getValue(this.$props.data, this.$props.prop),
        this.autoDecrypt
      )
    },
    getDecryptParams() {
      // 最好指定dataId且唯一，后端好做存储之后的查找
      const params = {
        dataId: this.decryptApi.getValue(this.$props.data, this.$props.idKey) || '0',
        fieldName: this.$props.prop,
        fieldContent: this.decryptApi.getMaskVal(this.$props.data, this.$props.prop),
        fieldNameStr: this.decryptApi.getValue(this.$props.data, this.$props.prop),
        buttonName: this.decryptApi.getValue(this.$props.data, this.$props.name)
      }
      return params
    },
    async handleClick() {
      // 已经解密过，不需要在解密，除非数据更新。
      this.$emit('click', this.$props.data, this.decrypted)
      if (this.decrypted) {
        return
      }
      // 是否为监控字段
      const isMask = this.decryptApi.isMask(this.$props.data, this.$props.prop)
      if (!isMask) {
        return
      }
      // 获取解密参数
      const params = this.getDecryptParams()
      // 调用公共解密弹窗，确定是否解密
      const res = await this.decryptApi.decrypt(params, 'mask')
      if (res !== null) {
        // 赋值
        this.data[this.$props.prop] = res
        // 解密成功事件抛出
        this.$emit('decrypt-success', res, this.$props.data)
        // 修改本地解密状态
        this.setDecryptStatus(true)
      }
    },
    async decrypt() {
      // 获取解密参数
      const params = this.getDecryptParams()
      // 调用解密接口，不弹弹窗
      const res = await this.$http('syslog.sensitiveFieldViewLog.save', params)
      // 解密成功事件抛出
      this.$emit('decrypt-success', res, this.$props.data)
      return res
    },
    async autoDecrypt() {
      // 执行自动解密逻辑
      if (this.decrypted && this.unauto !== true) {
        const res = await this.decrypt()
        if (res !== null) {
          // 赋值
          this.data[this.$props.prop] = res
          // 自动解密成功事件抛出
          this.$emit('auto-decrypt-success', res, this.$props.data)
        }
      }
    },
    setDecryptStatus(val) {
      // 设置解密状态
      this.decrypted = val
    }
  }
}




// WEBPACK FOOTER //
// ./src/public/components/kye-field-decrypt/component.js